import { render } from "./TvmSlideOutBbTradeValue.vue?vue&type=template&id=5e1bb30a&scoped=true"
import script from "./TvmSlideOutBbTradeValue.vue?vue&type=script&lang=js"
export * from "./TvmSlideOutBbTradeValue.vue?vue&type=script&lang=js"

import "./TvmSlideOutBbTradeValue.vue?vue&type=style&index=0&id=5e1bb30a&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1bb30a"]])

export default __exports__